import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StudentCounsellingDetailsService } from '../student-counselling-details.service';

@Component({
  selector: 'app-student-counselling-details-page',
  templateUrl: './student-counselling-details-page.component.html',
  styleUrls: ['./student-counselling-details-page.component.scss']
})
export class StudentCounsellingDetailsPageComponent {
  shows: true
 @Input() ids: { reportId: any; counselId: any };
  @Output() counseback = new EventEmitter
  private token = "eyJhbGciOiJIUzI1NiJ9.eyJwYXlyb2xsSWQiOiJIWUQxMDMxMzUiLCJtb2JpbGVObyI6IjgyOTc2NzAxOTciLCJ0eXBlIjoiU3R1ZGVudENvdW5zZWxsaW5nIiwiZXhwIjoxNzkxMTE5ODkzLCJ1c2VySWQiOiJIWUQxMDMxMzUiLCJpYXQiOjE3MDQ3MTk4OTMsInVuaXF1ZUlkIjoyODQ4NiwianRpIjoiNTc1ZDQ0NmQtNWRhOC00MzM0LTk1NzYtYzc0NjA0MmM3OGVhIn0.jSQ-vntHnteUgUEktHDQ8OYv3q8O2o9h8us-7ERIlG8"
  studentData: any;
  BehavioralReasons: any;
  SocialConcerns: any;
  selfAcademic: any;
  Appearance: any;
  Attitude: any;
  MotorBehaviour: any;
  Perceptions: any;
  Affect: any;
  Mood: any;
  Orientation: any;
  Speech: any;
  ThoughtContent: any;
  ThoughtProcess: any;
  Memoryconcentration: any;
  InsightJudgment: any;
  profileForm: any;
  casenote: any;
  data: any;
  referredBy: any;
  anyOtherReasons: any;
  familyHistory: any;
  caseHistory: any;
  date: any;
  refferalIfAny: any;
  clinicalPsychologist: any;
  psychiatrist: any;
  outCome: any;
  isInputDisabled: boolean = false;
  sumbited = false
  stdCounselReasons: any;
  appearance: boolean;
  attitude: boolean;
  motorBehaviour: boolean;
  perceptions: boolean;
  affect: boolean;
  speech: boolean;
  mood: boolean;
  orientation: boolean;
  thoughtContent: boolean;
  thoughtProcess: boolean;
  memoryconcentration: boolean;
  thoughtProcessradio: boolean;
  thoughtProcessradios: boolean;
  throughtContent: any;
  throughtContents: any;
  isButtonDisabled: boolean = false;
  searchCriteria: string = '';
  resetform: any;
  lastFollowUpDate: any;
  selectedOption: boolean;
  isListReadonly: boolean = true
  AcademicConcerns: any[];
  EnviornmentalConcerns: any[];
  PersonalConcerns: any[];
  ConcernsCognition: any[];
  SelfharmSuicidalTendencies: any[];
  app: any;
  studentPhotoUrl: any
  uniqueRefId: any;

  constructor(private dataService: StudentCounsellingDetailsService, private fb: FormBuilder, private snackbar: MatSnackBar, public http: HttpClient,) {

    this.profileForm = this.fb.group({
      referredBy: ["", Validators.required],
      anyOtherReasons: ["", Validators.required],
      caseHistory: ["", Validators.required],
      familyHistory: ["", Validators.required],
      caseNotes: ["", Validators.required],
      counselDate: ["", Validators.required],
      followUp: ["", Validators.required],
      outCome: ["", Validators.required],
      refferalIfAny: ["", Validators.required],
      clinicalPsychologist: ["", Validators.required],
      psychiatrist: ["", Validators.required],
      appearance: ["", Validators.required],
      attitude: ["", Validators.required],
      motorBehaviour: ["", Validators.required],
      perceptions: ["", Validators.required],
      affect: ["", Validators.required],
      mood: ["", Validators.required],
      speech: ["", Validators.required],
      Orientation: ["", Validators.required],
      thoughtContent: ["", Validators.required],
      thoughtProcess: ["", Validators.required],
      MemoryConcentration: ["", Validators.required],
      followUpdate: ["", Validators.required],
      // Radio1:["",Validators.required],
      // Radio2:["",Validators.required]
    })
  }
  ngOnInit() {

    this.search()

    this.dataService.getdata().subscribe((res: any) => {
      this.studentData = res.stdCounselCatmain;
      this.BehavioralReasons = this.getReasonsByCounselCatId(1);
      this.SocialConcerns = this.getReasonsByCounselCatId(2);
      this.selfAcademic = this.getReasonsByCounselCatId(3);
      this.Appearance = this.getReasonsByCounselCatId(4);
      this.Attitude = this.getReasonsByCounselCatId(5);
      this.MotorBehaviour = this.getReasonsByCounselCatId(6);
      this.Perceptions = this.getReasonsByCounselCatId(7);
      this.Affect = this.getReasonsByCounselCatId(8);
      this.Mood = this.getReasonsByCounselCatId(9);
      this.Speech = this.getReasonsByCounselCatId(10);
      this.Orientation = this.getReasonsByCounselCatId(11);
      this.ThoughtContent = this.getReasonsByCounselCatId(12);
      this.ThoughtProcess = this.getReasonsByCounselCatId(13);
      this.Memoryconcentration = this.getReasonsByCounselCatId(14);
      this.InsightJudgment = this.getReasonsByCounselCatId(15);
      this.AcademicConcerns = this.getReasonsByCounselCatId(16)
      this.EnviornmentalConcerns = this.getReasonsByCounselCatId(17)
      this.PersonalConcerns = this.getReasonsByCounselCatId(18)
      this.ConcernsCognition = this.getReasonsByCounselCatId(19)
      this.SelfharmSuicidalTendencies = this.getReasonsByCounselCatId(20)
      console.log(this.studentData);


    }, (error: any) => {
      if (error.status === 401) {
        // this.accessDenied = true;
      }
    }
    )


  }
//   ngOnChanges(changes: SimpleChanges) {

//   ✅ check ids object exists
//   if (!changes['ids'] || !changes['ids'].currentValue) {
//     return;
//   }

//   const { reportId, counselId } = changes['ids'].currentValue;

//   ✅ HARD STOP if any id missing
//   if (!reportId || !counselId) {
//     console.warn('IDs not ready, API not triggered');
//     return;
//   }

//   ✅ ONLY NOW call API
//   this.search();
// }

  isItemChechecked(item: any) {

    let found: any;
    found = this.data?.stdCounselReasonsList?.stdCounselReasons.find((data: any) => data.counselCatRsnId == item.counselCatRsnId);
    return found ? true : false;
  }
  getReasonsByCounselCatId(counselCatId: number): any[] {
    const category = this.studentData.find((cat: any) => cat.counselCatId === counselCatId);
    return category ? category.reasons : [];
  }
  assignPreviuosData(data: any) {
    console.log(data);



    if (this.data.stdCounselReasonsList) {
      this.casenote = this.data?.stdCounselReasonsList.caseNotes;
    }
    if (this.data.stdCounselReasonsList) {
      this.referredBy = this.data.stdCounselReasonsList.referredBy
    }
    if (this.data.stdCounselReasonsList) {
      this.anyOtherReasons = this.data.stdCounselReasonsList.anyOtherReasons
    }

    if (this.data.stdCounselReasonsList) {
      this.familyHistory = this.data.stdCounselReasonsList.familyHistory
    }
    if (this.data.stdCounselReasonsList) {
      this.caseHistory = this.data.stdCounselReasonsList.caseHistory
    }
    if (this.data.stdCounselReasonsList) {
      this.date = this.data.stdCounselReasonsList.counselDate
    }
    if (this.data?.outcomeList) {
      this.refferalIfAny = this.data.outcomeList[0].refferalIfAny
    }
    if (this.data?.outcomeList) {
      this.clinicalPsychologist = this.data.outcomeList[0].clinicalPsychologist
    }
    if (this.data?.outcomeList) {
      this.psychiatrist = this.data.outcomeList[0].psychiatrist
    }
    if (this.data?.outcomeList) {
      this.outCome = this.data?.outcomeList[0].outCome;
    }



    else {
      this.casenote = "No data";
    }
  }
  onBehaviurSelect(item: any, event: any, isFromRadiaoButton: any) {
    if (item.reasonName === 'Other' && item.counselCatId === 4) {
      this.appearance = !this.appearance

    }
    else if (item.reasonName === 'Other' && item.counselCatId === 5) {
      this.attitude = !this.attitude
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 6) {
      this.motorBehaviour = !this.motorBehaviour
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 7) {
      this.perceptions = !this.perceptions
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 8) {
      this.affect = !this.affect
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 9) {
      this.mood = !this.mood
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 10) {
      this.speech = !this.speech
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 11) {
      this.orientation = !this.orientation
    }
    else if (item.reasonName === 'Other' && item.counselCatId === 12) {
      this.thoughtContent = !this.thoughtContent
    }
    else if (item.reasonName === 'Others' && item.counselCatId === 13) {
      this.thoughtProcess = !this.thoughtProcess
    }
    else if (item.reasonName === 'Others' && item.counselCatId === 14) {
      this.memoryconcentration = !this.memoryconcentration
    }
    else if (item.reasonName === 'Suicidal Ideation' && item.counselCatId === 12) {
      this.thoughtProcessradio = !this.thoughtProcessradio
    }
    else if (item.reasonName === 'Homicidal Ideation' && item.counselCatId === 12) {
      this.thoughtProcessradios = !this.thoughtProcessradios
    }

  }
  onChange(reasonId: any, event: any) {
    console.log("ahiiii", event.target.value);
    this.stdCounselReasons.map((item: any) => {
      if (item.counselCatRsnId == reasonId) {
        item.otherRemarks = event.target.value;
        return
      }
    })
    console.log(this.stdCounselReasons);
  }
  radio(data: any, value: any) {
    // alert(data)
    // alert(value);
    this.stdCounselReasons.map((item: any) => {
      if (item.counselCatRsnId == data.counselCatRsnId) {
        if (value == 'none') {
          item.none = true;
          item.active = false;
          item.passive = false
        } else if (value == 'active') {
          item.active = true;
          item.passive = false
          item.none = false;
        } else if (value == 'passive') {
          item.passive = true;
          item.none = false;
          item.active = false;
        }

        (item.counselCatRsnId === 63) ? this.throughtContent = item : this.throughtContents = item;
        return
      }
    })
  }
  search() {
    this.isButtonDisabled = false
    this.throughtContent = ""
    this.throughtContents = ""
    this.dataService.searchData(this.ids.reportId).subscribe((response: any) => {
      this.data = response
      this.uniqueRefId = this.data.counselStdDetails[0].uniqueRefId
      this.getImage(this.uniqueRefId)
      if (this.data?.followUpList[this.data?.followUpList.length - 1].followUp !== '') {
        this.lastFollowUpDate = this.findLastFollowUpDate(this.data?.followUpList);
        console.log('Last Follow-up Date:', this.lastFollowUpDate);

        console.log("FOllow Up Exist SHow FOllow up Date and COmment Test");
      }
      else {
        this.lastFollowUpDate = this.data?.stdCounselReasonsList.counselDate
        console.log("No Follow up no data to dispaly")
      }



      let otherdata = this.data.stdCounselReasonsList?.stdCounselReasons.filter((item: any) => {
        return item.otherRemarks != ""
      })
      let radiodata = this.data?.stdCounselReasonsList?.stdCounselReasons?.filter((item: any) => {
        return item.passive || item.active || item.none == true
      })
      console.log("other", otherdata);
      console.log("radio", radiodata);


      if ('followUpList' && 'stdCounselReasonsList' && 'outcomeList' in this.data) {
        this.isButtonDisabled = true
      }

      console.log(otherdata);
      otherdata?.map((item: any) => {
        if (item.counselCatRsnId === 29) {
          this.appearance = !this.appearance
          this.profileForm.controls['appearance'].setValue(item.otherRemarks)

        }
        if (item.counselCatRsnId === 32) {
          this.attitude = !this.attitude
          this.profileForm.controls['attitude'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 35) {
          this.motorBehaviour = !this.motorBehaviour
          this.profileForm.controls['motorBehaviour'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 38) {
          this.perceptions = !this.perceptions
          this.profileForm.controls['perceptions'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 45) {
          this.affect = !this.affect
          this.profileForm.controls['affect'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 51) {
          this.mood = !this.mood
          this.profileForm.controls['mood'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 56) {
          this.speech = !this.speech
          this.profileForm.controls['speech'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 62) {
          this.orientation = !this.orientation
          this.profileForm.controls['Orientation'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 68) {
          this.thoughtContent = !this.thoughtContent
          this.profileForm.controls['thoughtContent'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 73) {
          this.thoughtProcess = !this.thoughtProcess
          this.profileForm.controls['thoughtProcess'].setValue(item.otherRemarks)
        }
        if (item.counselCatRsnId === 78) {
          this.memoryconcentration = !this.memoryconcentration
          this.profileForm.controls['MemoryConcentration'].setValue(item.otherRemarks)
        }
      })
      radiodata?.map((item: any) => {
        if (item.counselCatRsnId === 63) {
          console.log("test", item);
          this.throughtContent = item
          this.thoughtProcessradio = !this.thoughtProcessradio
        }
        if (item.counselCatRsnId === 64) {
          this.throughtContents = item
          this.thoughtProcessradios = !this.thoughtProcessradios
        }
      })

      if (this.data) {
        this.assignPreviuosData(this.data.stdCounselReasonsList.stdCounselReasons)
        console.log("behaviour", this.stdCounselReasons);
      }


      if (this.data == null || this.data.length <= 0) {
        window.alert("please enter valid admission number")
        this.snackbar.open('plase Enter the Valid admission number', 'Close', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'end'
        })
      }

      console.log('API Response1:', this.data);
    });


    this.stdCounselReasons = []
  }
  findLastFollowUpDate(followUpList: any[]): string {
    // if (!Array.isArray(followUpList)) {
    //   console.error('followUpList is not an array');
    //   return '';
    // }
    let lastDate: Date = new Date(0); // Initialize with a minimal date

    for (const followUp of followUpList) {
      const followUpDate = new Date(followUp.followUpDate);

      if (followUpDate > lastDate) {
        lastDate = followUpDate;
      }
    }

    return lastDate.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
  }

  send() {
    this.counseback.emit({ page: 1 })
  }
  sends() {
    // this.shows=false
  }
  getImage(emp: any) {

    const fallbackImage = 'assets/image/employee_notpresent.jpg';
    this.dataService.getimage(emp).subscribe({
      next: (blob: Blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);

        reader.onloadend = () => {
          this.studentPhotoUrl = reader.result ? (reader.result as string) : fallbackImage;
        };
      },
      error: () => {
        this.studentPhotoUrl = fallbackImage;
      }
    });
  }

}
